module.exports = __webpack_public_path__ + "static/img/preview-02.8829355b.webp";